import { render } from "./MdCardActions.vue?vue&type=template&id=2a08130b"
import script from "./MdCardActions.vue?vue&type=script&lang=js"
export * from "./MdCardActions.vue?vue&type=script&lang=js"

import "./MdCardActions.vue?vue&type=style&index=0&id=2a08130b&lang=scss"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__